import React from 'react'
import { Box, Text, Stack } from '@chakra-ui/react'
import { Address } from '@Types'

export interface BeneficiarySectionProps {
  isThirdParty: boolean
  beneficiaryName?: string
  bankAccountNumber: string
  beneficiaryAddress: Address
}

const BeneficiarySection = ({
  isThirdParty,
  beneficiaryName = '',
  bankAccountNumber,
  beneficiaryAddress
}: BeneficiarySectionProps) => {
  return (
    <Stack spacing={2}>
      <Text as='h3' textStyle='h3'>
        Beneficiary
      </Text>
      <Stack spacing={4}>
        <Stack direction='row' w='100%' spacing={4}>
          <Box w='50%' data-testid='isThirdParty'>
            <Text fontWeight='bold'>Third Party</Text>
            <Text>{isThirdParty ? 'Yes' : 'No'}</Text>
          </Box>
          {!isThirdParty && (
            <Box w='50%'>
              <Text fontWeight='bold'>Beneficiary Name</Text>
              <Text>{beneficiaryName}</Text>
            </Box>
          )}
        </Stack>
        <Stack direction='row' w='100%'>
          {isThirdParty && (
            <Box w='50%'>
              <Text fontWeight='bold'>Beneficiary Name</Text>
              <Text>{beneficiaryName}</Text>
            </Box>
          )}
          <Box w='50%'>
            <Text fontWeight='bold'>Bank Account # or IBAN</Text>
            <Text>{bankAccountNumber}</Text>
          </Box>
        </Stack>
        {isThirdParty && (
          <Stack direction='row' w='100%'>
            <Box w='50%'>
              <Text fontWeight='bold'>Beneficiary Address</Text>
              <Stack spacing={0}>
                <Text>{beneficiaryAddress.address}</Text>
                {beneficiaryAddress.addressLine2 && <Text>{beneficiaryAddress.addressLine2}</Text>}
                <Text>
                  {beneficiaryAddress.city}
                  {beneficiaryAddress.stateProvince ? `, ${beneficiaryAddress.stateProvince}` : ''}{' '}
                  {beneficiaryAddress.postalCode}
                </Text>
                <Text>{beneficiaryAddress.country}</Text>
              </Stack>
            </Box>
          </Stack>
        )}
      </Stack>
    </Stack>
  )
}

export default BeneficiarySection
